import { render } from "./young_talent.vue?vue&type=template&id=5c2a9828"
import script from "./young_talent.vue?vue&type=script&lang=js"
export * from "./young_talent.vue?vue&type=script&lang=js"

import "./young_talent.vue?vue&type=style&index=0&id=5c2a9828&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__